import React from "react";
import { Box } from "@mui/material";
import TickIcon from "@/assets/icons/lead-page/tick-icon";

const Tick: React.FC = () => (
  <Box
    sx={{
      position: "absolute",
      top: "0px",
      right: "0px",
      zIndex: 2,
      width: "7.5px",
      height: "7.5px",
      borderRadius: "50%",
      backgroundColor: "#B6E9D1",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <TickIcon />
  </Box>
);

export default Tick;
